import { Eyebrow } from "@/components/site/Reveal";
import { RequestButton, WhatsAppButton } from "@/components/site/Buttons";
import { usePageMeta } from "@/lib/usePageMeta";

export default function ComingSoon({ title }) {
  usePageMeta(`${title} | NE Tool Repair`, `${title} — NE Tool Repair, power tool repair in Newcastle and the North East.`);
  return (
    <section className="min-h-[70vh] grid-lines border-b border-[var(--line)]" data-testid="coming-soon-page">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10 py-24 md:py-36">
        <Eyebrow>Page in progress</Eyebrow>
        <h1 className="mt-6 font-display font-black uppercase text-5xl sm:text-6xl lg:text-8xl leading-[0.9]">{title}</h1>
        <p className="mt-6 max-w-lg text-sm md:text-base text-[var(--grey)]">This page is being built. In the meantime, message us on WhatsApp.</p>
        <div className="mt-10 flex flex-col sm:flex-row gap-3"><RequestButton testId="soon-request-btn" /><WhatsAppButton testId="soon-whatsapp-btn" /></div>
      </div>
    </section>
  );
}
